import GetNamespaceByIdRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/GetNamespaceByIdRequest";
import GetNamespaceByIdResponse from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/GetNamespaceByIdResponse";
import { NamespaceModel, UpdateNamespaceModel } from "../models";
import ProjectNamespaceUpdateRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/ProjectNamespaceUpdateRequest";
import { IconColorType, IconType } from "tir-components";
import GetColorListResponse from "@/api/Main/dataSource/api/projects/groups/i-service/model/setting-color/GetColorListResponse";
import GetIconListResponse from "@/api/Main/dataSource/api/projects/groups/i-service/model/setting-icon/GetIconListResponse";

export const mapGetNamespaceRequest = (namespaceId: string) =>
  new GetNamespaceByIdRequest({
    NamespaceId: namespaceId,
  });

export const mapGetNamespaceResponse = (response: GetNamespaceByIdResponse) =>
  new NamespaceModel({
    Id: response.NamespaceId,
    Name: response.Name,
    IconId: response.IconId,
    IconUrl: response.IconUrl,
    ColorId: response.ColorId,
    Color: response.Color,
  });

export const mapUpdateNamespaceRequest = (request: UpdateNamespaceModel) =>
  new ProjectNamespaceUpdateRequest({
    Id: request.Id,
    Name: request.Name,
    IconId: request.IconId,
    ColorId: request.ColorId,
  });

export const mapGetIconsResponse = (response: GetIconListResponse) =>
  response.Items.map<IconType>((item) => {
    return {
      IconId: item.IconId,
      IconUrl: item.IconUrl,
    };
  });

export const mapGetColorsResponse = (response: GetColorListResponse) =>
  response.Items.map<IconColorType>((item) => {
    return {
      ColorId: item.Id,
      Color: item.Color,
    };
  });
